import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductPage.scss';
import Breadcrumb from '../../components/common/Breadcrumb';

const DoubleSided = () => {
  const { subcategory } = useParams();
  const navigate = useNavigate();

  const productImages = {
    whaja: '/images/tape1.png',
    hotmelt: '/images/tape1.png',
    pet90: '/images/tape1.png',
    kraft: '/images/tape3.png',
    crown: '/images/tape10.png',
  };

  const products = {
    whaja: {
      title: '화지양면 테이프',
      eng: 'Whaja Double-Sided Tape',
      desc: '봉투, 종이류, 쇼핑백 접착 등 범용 작업에 폭넓게 사용되는 대표적인 양면테이프입니다.',
      summary: {
        productName: '화지(아크릴) 양면테이프',
        usage: '봉투 및 쇼핑백 접착 외',
        size: '7*30 / 8*30 / 10*30 외',
      },
      strengths: ['우수한 유연성/강한 즉시접착력', '뛰어난 가공성', '낮은 가격', '다양한 두께 옵션'],
      cautions: [
        '고온 환경에서는 성능이 저하될 수 있습니다.',
        '습기 및 물에 장시간 노출되는 환경에는 적합하지 않습니다.',
      ],
      tableHeaders: ['모델명', '기재', '점착제', '두께(mm)', '색상', '점착력(gf/in)', '내열성'],
      tableRows: [
        ['A-70', '화지', '솔벤트 (아크릴)', '0.07', '불투명', '1,200', '80'],
        ['A-100', '화지', '솔벤트 (아크릴)', '0.1', '불투명', '1,600', '80'],
        ['A-160', '화지', '솔벤트 (아크릴)', '0.16', '불투명', '2,100', '100'],
      ],
    },
    hotmelt: {
      title: '핫멜트양면 테이프',
      eng: 'Hot-melt Double-Sided Tape',
      desc: '즉시 접착력이 우수한 핫멜트 타입으로 포장, 봉합, 임가공 등 다양한 산업 현장에서 사용됩니다.',

      summary: {
        productName: '핫멜트 양면테이프',
        usage: '포장 / 봉합 / 임가공',
        size: '1000*50 / 1000*500 / 1000*28 외',
      },

      strengths: [
        '즉시 접착력 우수(High Tack)',
        '냉동/저온 환경에서 안정적인 성능',
        '자동 포장라인에 최적화된 빠른 접착 속도',
        '多기질(골판지,필름,PP/PE)에 우수한 부착력',
        '경제적 가격 구조로 대량 사용에 적합',
      ],

      cautions: ['내열성에 약함(50도 이상에서 접착력이 떨어짐)', '빠른 노화 진행'],

      tableHeaders: ['모델명', '기재', '점착제', '두께(mm)', '색상', '점착력(gf/in)', '내열성'],

      tableRows: [
        ['H-100', '화지', '핫멜트', '0.1', '불투명', '1,800', '60'],
        ['H-130', '화지', '핫멜트', '0.13', '불투명', '2,400', '60'],
      ],
    },
    pet90: {
      title: 'PET 양면 테이프',
      eng: 'PET Double-Sided Tape',
      desc: '고투명 PET 기재를 적용해 치수 안정성과 내열성이 우수한 산업용 양면테이프입니다.',
      summary: {
        productName: 'PET 양면테이프',
        usage: '전자부품 고정 외',
        size: '1000*50 외',
      },
      strengths: [
        '매우 높은 강도와 내구성',
        '내열성 우수',
        '화학성 우수',
        '얇고 균일한 두께',
        '제거 후 점착 잔사가 적게 남음',
        '전기적 절연 특성',
      ],
      cautions: ['거친 표면보다는 평활한 표면에 적합', '강한 충격이 반복되는 환경은 사전 테스트 권장'],
      tableHeaders: ['모델명', '기재', '점착제', '두께(mm)', '색상', '점착력(gf/in)', '내열성'],
      tableRows: [['PET-90', 'PET', '솔벤트(아크릴)', '90', '반투명', '1,100', '150']],
    },
    kraft: {
      title: '크라프트 양면테이프',
      eng: 'Kraft Tape',
      desc: '손으로 절단이 쉽고 작업성이 좋아 포장, 마감, 친환경 패키징에 적합한 제품입니다.',
      summary: {
        productName: '크라프트 양면테이프',
        usage: '창고 물류 라벨링 / 간단한 고정',
        size: '1000*50 / 1000*25 외 다수',
      },
      strengths: [
        '친환경 포장 적합(박스분리 시 그대로 배출 가능)',
        '강력한 접착력과 안정적 포장성능',
        '필기 가능하여 라벨, 창고 작업에 적합',
        '테이핑 시 소음이 없음',
        '손으로 쉽게 절단 가능',
        '박스와 자연스러운 색감 매칭',
        '친환경 브랜딩 포장에 최적',
      ],
      cautions: ['무거운 하중에는 부적합', '비, 습기에는 취약'],
      tableHeaders: ['모델명', '기재', '점착제', '두께(mm)', '색상', '180° Peeling Strength (kg/25mm)', '내열성'],
      tableRows: [['K110', '화지', '솔벤트(아크릴)', '0.12', '반투명', '2.0 ± 0.2 kg (스틸기준)', '150']],
    },
    crown: {
      title: '인쇄양면 테이프',
      eng: 'Crown Double-Sided Tape',
      desc: '봉투, 종이류, 쇼핑백 접착 등 범용 작업에 폭넓게 사용되는 대표적인 양면테이프입니다.',
      summary: {
        productName: '화지(아크릴) 양면테이프',
        usage: '봉투 및 쇼핑백 접착 외',
        size: '7*30 / 8*30 / 10*30 외',
      },
      strengths: ['우수한 유연성/강한 즉시접착력', '뛰어난 가공성', '낮은 가격', '다양한 두께 옵션'],
      cautions: [
        '고온 환경에서는 성능이 저하될 수 있습니다.',
        '습기 및 물에 장시간 노출되는 환경에는 적합하지 않습니다.',
      ],
      tableHeaders: ['모델명', '기재', '점착제', '두께(mm)', '색상', '점착력(gf/in)', '내열성'],
      tableRows: [['A-100', '화지', '솔벤트 (아크릴)', '0.1', '불투명', '1,600', '80']],
    },
  };

  const currentKey = subcategory || 'whaja';
  const current = products[currentKey] || products.whaja;

  return (
    <div className="sub-page product-page">
      <section className="sub-visual product">
        <div className="container">
          <span className="sub-title">PRODUCT</span>
          <h1>제품소개</h1>
          <p>베스트트레이딩의 검증된 점착 솔루션입니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className="active" onClick={() => navigate('/products/double-sided/whaja')}>
              양면 테이프
            </button>
            <button onClick={() => navigate('/products/industrial/masking')}>산업용 테이프</button>
            <button onClick={() => navigate('/products/foam/eva')}>폼 테이프</button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        <nav className="product-tabs">
          {Object.keys(products).map((key) => (
            <button
              key={key}
              className={currentKey === key ? 'active' : ''}
              onClick={() => navigate(`/products/double-sided/${key}`)}
            >
              {products[key].title}
            </button>
          ))}
        </nav>

        <div className="product-detail-view">
          <div className="detail-main">
            {/* 좌측 이미지 영역 */}
            <div className="img-area">
              <div className="img-box">
                <img src={productImages[currentKey]} alt={current.title} />
              </div>

              {/* <div className="action-btns">
                <button className="btn-sample" onClick={() => navigate('/request-sample')}>
                  샘플 요청
                </button>
                <button className="btn-quote" onClick={() => navigate('/request-quote')}>
                  견적 문의
                </button>
              </div> */}
            </div>

            {/* 우측 정보 영역 - 표 형태로 변경 */}
            <div className="info-area info-area-redesign">
              <div className="product-head">
                <span className="eng-title">{current.eng}</span>
                <h2>{current.title}</h2>
                <p className="main-desc">{current.desc}</p>
              </div>

              <div className="spec-table-container">
                <table className="spec-table">
                  <tbody>
                    <tr>
                      <th>품명</th>
                      <td>
                        <strong>{current.summary.productName}</strong>
                      </td>
                    </tr>
                    <tr>
                      <th>사용처</th>
                      <td>{current.summary.usage}</td>
                    </tr>
                    <tr>
                      <th>특장점</th>
                      <td>
                        <ul className="spec-list strengths">
                          {current.strengths.map((s, idx) => (
                            <li key={idx}>{s}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <th>규격</th>
                      <td>{current.summary.size}</td>
                    </tr>
                    <tr>
                      <th>주의사항</th>
                      <td>
                        <ul className="spec-list cautions">
                          {current.cautions.map((c, idx) => (
                            <li key={idx}>{c}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* 하단 상세 데이터 - 100% 넓이 */}
          <div className="data-table-wrap full-width">
            <div className="table-title">상세 규격 데이터 (Technical Specification)</div>
            <div className="table-scroll">
              <table className="product-data-table">
                <thead>
                  <tr>
                    {current.tableHeaders.map((head, idx) => (
                      <th key={idx}>{head}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {current.tableRows.map((row, rowIdx) => (
                    <tr key={rowIdx}>
                      {row.map((cell, cellIdx) => (
                        <td key={cellIdx}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoubleSided;
